import { useCallback as e, useLayoutEffect as t, useRef as n } from "react";
import { noop as r } from "es-toolkit/compat";
//#region src/hooks/useMutationObserver.ts
var i = {
	attributes: !0,
	childList: !1,
	subtree: !1
}, a = (e) => typeof e == "object" && !!e && Object.hasOwn(e, "current"), o = (e) => a(e) ? e.current : e, s = (a, s = r, c = i) => {
	let l = n(null), u = e(() => l.current?.disconnect(), []), d = e(() => {
		let e = o(a);
		e && (l.current = new MutationObserver(s), l.current.observe(e, c));
	}, [
		s,
		c,
		a
	]);
	t(() => (d(), () => u()), [u, d]);
};
//#endregion
export { s as default };

//# sourceMappingURL=useMutationObserver.js.map